<template>
  <div id="dscroll" class="m-scrollable--track m-scroller ps ps--active-y" data-scrollable="true" style="overflow: hidden;">
    <div class="m-portlet m-portlet--mobile">
      <PageHead label='住宿管理' label2="房间视图" url="/cycle/stay/list"></PageHead>
      <div class="m-portlet__body" style="padding: .2rem 2.2rem;">
        <!--begin: Search Form -->
        <div class="m-form m-form--label-align-right">
          <SearchNormalText v-model='condition.roomname' label='房间'></SearchNormalText>
          <div style="float: left;margin-top: 10px;">
            <div class="m-form__group m-form__group--inline">
              <div class="m-form__label">
                <label style="width: 100px;text-align:right;">入住开始月度：</label>
              </div>
              <div class="m-form__control">
                <el-date-picker v-model="condition.staystartdate" type="month" placeholder="入住开始月度" value-format="yyyy-MM">
                </el-date-picker>
              </div>
            </div>
            <div class="d-md-none m--margin-bottom-10"></div>
          </div>
          <div style="float: left;margin-top: 10px;">
            <div class="m-form__group m-form__group--inline">
              <div class="m-form__label">
                <label style="width: 100px;text-align:right;">入住结束月度：</label>
              </div>
              <div class="m-form__control">
                <el-date-picker v-model="condition.stayenddate" type="month" placeholder="入住结束月度" value-format="yyyy-MM">
                </el-date-picker>
              </div>
            </div>
            <div class="d-md-none m--margin-bottom-10"></div>
          </div>
          
        </div>
        <div style="clear: both;"></div>
        <div class="m--margin-top-10 m--margin-bottom-10" style="width: 100%;text-align: center;float: initial;">
          <el-button type="primary" icon="el-icon-search" @click="Search(1)">查询</el-button>
          <ExportButton :url='exportUrl' buttonname="导出"></ExportButton>
        </div>
        <!--end: Search Form -->
        <div class="m-portlet__body" style="padding: .2rem 2.2rem;">
          <!--begin: Datatable -->
          <el-table :data="tableData" style="width: 100%" size="medium">
            <el-table-column fixed label="房间" width="150">
              <template slot-scope="scope">
                {{scope.row.RoomName}}
              </template>
            </el-table-column>
            <el-table-column width="160" v-for="col in cols" :label="col.label" v-bind:key="col.prop">
              <template slot-scope="scope">
                <div v-html="formatRoomInfo(scope.row[col.prop])"></div>
              </template>
            </el-table-column>
          </el-table>
          <!--end: Datatable -->
          <div style="margin-top: 10px;text-align: center;" v-if="this.condition.recordCount > 0">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="condition.currentPage"
              :page-sizes="[2, 10, 20, 30, 40]" :page-size="condition.pageSize" layout="total, sizes, prev, pager, next, jumper"
              :total="condition.recordCount">
            </el-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'RoomList',
    data() {
      return {
        condition: {
          roomname: '',
          staystartdate: '',
          stayenddate: '',
          token: '',
          pageSize: 10,
          currentPage: 1,
          recordCount: 0,
          firstSearch: true
        },
        tableData: null,
        searchUrl: this.$utils.Url.zpgl + '/api/APIRoom/RoomRecordDetailList',
        exportUrl:this.$utils.Url.zpgl + '/api/APIRoom/RoomRecordDetailListOut',
        cols: [],
        loading: true,
        fullscreenLoading: false
      }
    },
    filters: {
      formatDate(val) {
        var now = new Date(val)
        var y = now.getFullYear()
        var m = now.getMonth() + 1
        return y + '-' + (m < 10 ? '0' + m : m)
      }
    },
    methods: {
      // 调整每页显示数
      // 调整每页显示数
      handleCurrentChange: function(val) {
        this.condition.currentPage = val
        this.Search()
      },
      // 分页操作
      handleSizeChange: function(val) {
        this.condition.pageSize = val
        this.condition.currentPage = 1
        this.Search()
      },
      GetMonthRange: function(startdate, enddate) {
        this.cols = []
        var start = startdate.split("-")
        var end = enddate.split("-")
        var min = new Date()
        var max = new Date()
        min.setFullYear(start[0], start[1] * 1 - 1, 1)
        max.setFullYear(end[0], end[1] * 1 - 1, 1)
        var curr = min
        while (curr <= max) {
          var month = curr.getMonth() + 1
          var strMonth = ''
          if (month < 10) {
            strMonth = '0' + month
          } else {
            strMonth = month
          }
          var strProp = curr.getFullYear() + '' + strMonth
          var strLabel = curr.getFullYear() + "-" + strMonth
          var arg = {
            prop: strProp,
            label: strLabel
          }
          this.cols.push(arg)
          curr.setMonth(month)
        }
      },
      formatRoomInfo: function(val) {
        var info = ''
        if (val != null) {
          var stuinfos = val.split(',')
          for (var i = 0; i < stuinfos.length; i++) {
            if ((i + 1) % 3 == 0) {
              if (i == 0) {
                info += stuinfos[i] + ','
              } else {
                if (i == stuinfos.length - 1) {
                  info += stuinfos[i] + ','
                } else {
                  info += stuinfos[i] + '<br>'
                }
              }
            } else {
              info += stuinfos[i] + ','
            }
          }
          info = info.substring(0, info.length - 1)
        }
        return info
      },
      Search: function(pageindex) {
        this.GetMonthRange(this.condition.staystartdate, this.condition.stayenddate)
        if (pageindex != null) {
          this.condition.currentPage = pageindex
        }
        this.$http.post(this.$utils.Url.zpgl + '/api/APIRoom/RoomRecordDetailList', this.condition)
          .then(res => {
            if (res.data.Code === 0) {
              this.tableData = res.data.Data
              this.condition.recordCount = res.data.Pager.RecordCount
            } else {
              this.$message({
                message: res.data.Msg + '，' + res.data.Error,
                type: 'error'
              })
            }
          })
          .catch(err => {
            this.tableData = ''
            this.condition.recordCount = 0
            console.log(err)
            this.$message({
              message: '查询失败',
              type: 'error'
            })
          })
      }
    },
    mounted: function() {
      this.condition.token = sessionStorage.getItem('token')
      var date = new Date()
      var year = date.getFullYear()
      this.condition.staystartdate = year + '-01'
      this.condition.stayenddate = year + '-12'
      this.Search()
    }
  }
</script>

<style scoped="scoped">
  /deep/.el-input {
    width: 220px;
  }
</style>
